import { render, staticRenderFns } from "./SurfInlineTwoTextStyle4.vue?vue&type=template&id=40b38bd2&scoped=true"
import script from "./SurfInlineTwoTextStyle4.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfInlineTwoTextStyle4.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfInlineTwoTextStyle4.vue?vue&type=style&index=0&id=40b38bd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b38bd2",
  null
  
)

export default component.exports